document.addEventListener('DOMContentLoaded', function () {
  const categorySelect = document.getElementById('ContactFormCategory');
  const drawerTitleEl = document.getElementById('categoryDrawerTitle');
  const drawerContentEl = document.getElementById('categoryDrawerContent');
  const messageBtn = document.getElementById('drawerMessageBtn');
  const portalBtn = document.getElementById('drawerPortalBtn');
  const drawerIconEl = document.getElementById('categoryDrawerIcon');

  if (!categorySelect) return;

  // Content map: add/extend as needed
  const ORDER_PORTAL_URL = 'https://orderlookup.dangleit.com/';
  
  const drawerMap = {
    'Order Status': {
        title: 'Order Status',
        html: `
        <p>
            You can view your order's status, Estimated Ship Date, and Estimated Delivery Date in real&nbsp;time on your 
            <a class="drawer-link" href="${ORDER_PORTAL_URL}" target="_blank" rel="noopener">Order Portal</a>.
        </p>
        <br>
        <p>
            We'll also be sure to send you periodic order status updates, including a shipping confirmation email with a tracking link, as soon as it ships!
        </p>
        `
    },

    'Estimated Delivery Date': {
        title: 'Estimated Delivery Date',
        html: `
        <p>
            You can view your order's status, Estimated Ship Date, and Estimated Delivery Date in real&nbsp;time on your 
            <a class="drawer-link" href="${ORDER_PORTAL_URL}" target="_blank" rel="noopener">Order Portal</a>.
        </p>
        <br>
        <p>
            We'll also be sure to send you periodic order status updates, including a shipping confirmation email with a tracking link, as soon as it ships!
        </p>
        `
    },

    'Edit Shipping Address': {
        title: 'Edit Shipping Address',
        html: `
        <p>
            You can easily edit your shipping address under the "Edit Address" section of your 
            <a class="drawer-link" href="${ORDER_PORTAL_URL}" target="_blank" rel="noopener">Order Portal</a>.
        </p>
        <br>
        <p>
            Please note that some actions, such as the ability to edit your shipping address, may become unavailable as your order reaches certain milestones within our system.
        </p>
        `
    },

    // Use this as the canonical content for both label variants
    'Edit Item(s)': {
        title: 'Edit Item Specifications',
        html: `
        <p>
            You can easily edit your item specifications under the "Edit Item(s)" section of your
            <a class="drawer-link" href="${ORDER_PORTAL_URL}" target="_blank" rel="noopener">Order&nbsp;Portal</a>
        </p>
        <br>
        <p>
            Please note that some actions, such as the ability to edit your item specifications, may become unavailable as your order reaches certain milestones within our system.
        </p>
        `
    },

    'Cancel Order': {
        title: 'Cancel Order',
        html: `
        <p>
            Changed your mind? You can cancel your order for a full refund, or edit your order details, on your 
            <a class="drawer-link" href="${ORDER_PORTAL_URL}" target="_blank" rel="noopener">Order Portal</a>.
        </p>
        <br>
        <p>
            Please note that some actions, such as the ability to cancel your order, may become unavailable as your order reaches certain milestones within our system.
        </p>
        `
    },

    'Replace/Return Item(s)': {
        title: 'Replace/Return Item(s)',
        html: `
        <p>
            Not 100% happy with your order? We've made it super easy to request a free replacement or refund through your 
            <a class="drawer-link" href="${ORDER_PORTAL_URL}" target="_blank" rel="noopener">Order Portal</a>.
        </p>
        <br>
        <p>
            Please note that all replacement/refund requests must be submitted via your order portal within 7 days of the courier's stated delivery date, per our store policy.
        </p>
        `
    }
    };

    const iconMap = {
    'Order Status': `
        <svg viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="12" r="9" stroke-linecap="round" stroke-linejoin="round"></circle>
        <path d="M9 12l2 2 4-4" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
    `,
    'Estimated Delivery Date': `
        <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M16 2v4M8 2v4M3 10h18" stroke-linecap="round"></path>
        <rect x="3" y="4" width="18" height="17" rx="2" ry="2"></rect>
        </svg>
    `,
    'Edit Shipping Address': `
        <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 22s-6-5-6-10a6 6 0 1 1 12 0c0 5-6 10-6 10z" stroke-linecap="round" stroke-linejoin="round"></path>
        <circle cx="12" cy="12" r="2.5"></circle>
        </svg>
    `,
    'Edit Item(s)': `
        <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M3 21l3-3 0 0 9-9 3 3-9 9 0 0H3v0z" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M14 6l2-2 3 3-2 2" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
    `,
    'Edit Item Specifications': `
        <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M3 21l3-3 0 0 9-9 3 3-9 9 0 0H3v0z" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M14 6l2-2 3 3-2 2" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
    `,
    'Replace/Return Item(s)': `
        <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M3 3v6h6" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M3 12a9 9 0 0 1 9-9" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M21 21v-6h-6" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M21 12a9 9 0 0 1-9 9" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
    `,
    'Cancel Order': `
        <svg viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="12" r="9"></circle>
        <path d="M15 9l-6 6M9 9l6 6" stroke-linecap="round"></path>
        </svg>
    `
    };

    // fallback icon (simple list)
    const defaultIcon = `
    <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M4 6h16M4 12h16M4 18h16" stroke-linecap="round"></path>
    </svg>
    `;


  // CTA actions
  messageBtn?.addEventListener('click', () => {
    // Scroll to the message box & focus (keeps user in flow)
    const msg = document.getElementById('ContactFormName');
    if (msg) {
      closeSidebar('categoryDrawer');
      msg.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => msg.focus(), 400);
    }
  });
  // portalBtn href is already set via HTML

  // Change handler for category
  categorySelect.addEventListener('change', function () {
    const val = this.value || ''; 
    if (!val || val === 'Other' || val == 'Bulk Pricing') {
      // If Other, just ensure drawer closed
      closeSidebar('categoryDrawer');
      return;
    }

    // Fill content dynamically
    const content = drawerMap[val] || {
      title: val,
      html: `<p>Please share details in the message box and we’ll help right away.</p>`
    };

    drawerTitleEl.textContent = content.title;
    drawerContentEl.innerHTML = content.html;

    // set icon
    if (drawerIconEl) {
    drawerIconEl.innerHTML = iconMap[val] || defaultIcon;
    }

    // Open the generic drawer
    openSidebar('categoryDrawer');
  });
});
